import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'

export default function useUsersList() {
  // Use toast
  const toast = useToast()

  const refEmailLogListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'subject', label: 'Konu', sortable: true },
    { key: 'created_at', label: 'Oluşturma Zamanı', sortable: true },

    { key: 'schdule_time', label: 'Mail Zamanı', sortable: false },
    { key: 'from_email', label: 'Gönderici', sortable: true },
    { key: 'transaction_user', label: 'İşlem Yapan', sortable: true },
    { key: 'total_mails', label: 'Toplam Alıcı', sortable: false },
    { key: 'success_mails', label: 'Giden', sortable: false },
    { key: 'error_mails', label: 'Gitmeyen', sortable: false },
    { key: 'not_responsing_mails', label: 'Belirsiz', sortable: false },
    { key: 'actions', label: '' },
  ]
  const perPage = ref(10)
  const totalEmailLogList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')

  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refEmailLogListTable.value ? refEmailLogListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalEmailLogList.value,
    }
  })

  const refetchData = () => {
    refEmailLogListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData()
  })

  const fetchEmailCategories = (ctx, callback) => {
    store
      .dispatch('app-email/fetchEmailSendDatas', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,
        category_id: router.currentRoute.params.category_id,
      })
      .then(response => {
        const { data } = response.data.data
        const { total } = response.data.meta

        callback(data)
        totalEmailLogList.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching email log list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*
  return {
    fetchEmailCategories,
    tableColumns,
    perPage,
    currentPage,
    totalEmailLogList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refEmailLogListTable,

    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
